import type { Workbench } from '@affine/core/modules/workbench';

export function normalizeChatPanelSessionId(
  sessionId: string | null | undefined
): string | undefined {
  if (!sessionId || sessionId === 'undefined' || sessionId === 'null') {
    return undefined;
  }
  return sessionId;
}

export function createChatPanelDocPath(
  docId: string,
  sessionId?: string | null
): string {
  const normalizedSessionId = normalizeChatPanelSessionId(sessionId);
  if (!normalizedSessionId) return `/${docId}`;

  const params = new URLSearchParams({ sessionId: normalizedSessionId });
  return `/${docId}?${params.toString()}`;
}

/** The path of a chat thread: at its doc when it has one, else the chat page. */
export function createChatThreadPath(
  sessionId: string,
  docId?: string | null
): string {
  if (docId) return createChatPanelDocPath(docId, sessionId);
  return `/chat?${new URLSearchParams({ sessionId }).toString()}`;
}

/**
 * The chat session a link asks for; it leaves the address once taken, so a
 * reload opens what was open last.
 */
export function takeChatSessionIdFromUrl(
  workbench: Pick<Workbench, 'location$' | 'activeView$'>
): string | undefined {
  const sessionId = normalizeChatPanelSessionId(
    new URLSearchParams(workbench.location$.value.search).get('sessionId')
  );
  if (sessionId) {
    workbench.activeView$.value.updateQueryString(
      { sessionId: undefined },
      { replace: true }
    );
  }
  return sessionId;
}
